import { Channel } from 'types/channels'

export const getSelectedAddress = (channelDetails: Channel, selectedProtocol: string) => {
  if (!channelDetails) return ''
  if (selectedProtocol === channelDetails?.protocol) return channelDetails?.address
  return (
    channelDetails?.alternatives?.find(p => p?.protocol === selectedProtocol)?.address ||
    channelDetails?.address
  )
}
